import { IPagedData, IClaim, IClaimDetail, INewClaimLine } from '../../types';
import Fetch from '../apiConfig/apiConfig';
import queryString from 'query-string';

interface IGetMyClaimsPageParams {
  dateFilter: string;
  storeId: number;
  currentPage: number;
  pageSize: number;
  currentFilter: number;
  search: string;
}

interface IResponse {
  response: IPagedData<IClaim>;
}

export const getMyClaimsPage = async (params: IGetMyClaimsPageParams): Promise<IPagedData<IClaim>> => {
  const axios = await Fetch();
  const { data } = await axios.get<IResponse>(
    `/my-claims/page?${queryString.stringify(params)}`,
  );

  return data.response;
};

export interface ISubmitClaimBody {
  orderNumber: string;
  lines: INewClaimLine[];
}

interface ISubmitClaimResponse {
  response: IClaim;
}

export const submitClaim = async (body: ISubmitClaimBody): Promise<IClaim> => {
  const axios = await Fetch();
  const response = await axios.post<ISubmitClaimResponse>('/orders/my-claims/create', body);
  return response.data.response;
};

interface IGetClaimDetailParams {
  orderNumber: string;
}

interface IGetClaimDetailResponse {
  response: IClaimDetail;
}

export const getClaimDetail = async (params: IGetClaimDetailParams): Promise<IClaimDetail> => {
  const axios = await Fetch();
  const { data } = await axios.get<IGetClaimDetailResponse>(
    `/my-claims/claim/get?${queryString.stringify(params)}`,
  );

  return data.response;
};
